<script setup lang="ts">
    import Social from "./Social.vue";

    const localePath = useLocalePath();
    const { signOut, status, getSession } = useAuth();
    const { currentRoute } = useRouter();
    const routeData = computed(() => currentRoute.value);

    const customSignOut = async () => {

        const { error } = await signOut({redirect: false })

        if (error){
            console.error(`ERROR SIGNOUT:${JSON.stringify(error)}`)
            throw createError({
                statusCode: 500,
                statusMessage: error,
            });
        } else {
            window.location.href=`/`
        }

    };

	const newsMediaJsonLd = {
		"@context": "https://schema.org",
		"@type": "NewsMediaOrganization",
		"name": "The Political Room",
		"url": "https://thepoliticalroom.com",
		"logo": {
			"@type": "ImageObject",
			"url": "https://thepoliticalroom.com/logo.svg"
		},
		"sameAs": [
			"https://x.com/Political_Room",
			"https://www.instagram.com/thepoliticalroom.tpr",
			"https://www.facebook.com/ThePoliticalRoomTPR",
			"https://www.youtube.com/channel/UCRmAzmoLNZxCvBQNlhtKLPw",
			"https://www.ivoox.com/perfil-the-political-room_a8_podcaster_19764770_1.html",
			"https://www.linkedin.com/company/the-political-room-tpr/about/",
			"https://podcasts.apple.com/es/podcast/the-political-room-una-mirada-a-la-actualidad/id1693560054"
		],
		"foundingDate": "2019-01-01",
		"description": "The Political Room es un medio de comunicación independiente especializado en análisis geopolítico, relaciones internacionales y conflictos.",
		"publisher": {
			"@type": "Organization",
			"name": "The Political Room"
		}
	}

    useHead({
		script: [
			{
				id: 'ld-news-org',
				type: 'application/ld+json',
				innerHTML: JSON.stringify(newsMediaJsonLd)
			}
		],
        link: [
            {
                rel: 'stylesheet',
                href: 'https://use.typekit.net/pvn3tin.css',
            },
            {
                rel: 'preconnect',
                href: 'https://fonts.googleapis.com',
            },
            {
                rel: 'preconnect',
                href: 'https://fonts.gstatic.com',
                crossorigin: 'anonymous',
            },
            {
                rel: 'stylesheet',
                href: 'https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap',
            },
        ],
    });

	const displayListCat = () => {
		document.getElementById('ul_cat')!.style.display = 'block'
	}

	const unDisplayList = () => {
		document.getElementById('ul_cat')!.style.display = 'none'
	}

	const displayListCatMobile = (e: MouseEvent) => {
		e.stopPropagation()
		const ul = document.getElementById('ul_cat_mobile')
		if (ul) {
			if (ul.classList.contains('ul-cat-mobile')) {
				ul.style.display = 'flex'
				ul.classList.remove('ul-cat-mobile')
			}
			else
			{
				ul.style.display = 'none'
				ul.classList.add('ul-cat-mobile')
			}
		}

	}

	const unDisplayListMobile = (th: boolean = false) => {

		const ul = document.getElementById('ul_cat_mobile')
		if (ul) {
			if (ul.classList.contains('ul-cat-mobile') && !th) {
				ul.style.display = 'flex'
				ul.classList.remove('ul-cat-mobile')
			}
			else
			{
				ul.style.display = 'none'
				ul.classList.add('ul-cat-mobile')
			}
		}
	}

</script>

<style>
    h6, h5, h4, h3, p, span, a, label {
        font-family: "Inter", serif;
        font-style: normal;
    }
</style>

<style scoped>

    .header-wrap .header-logo .footer-social-links {
       display: none;
    }
    .header-bottom {
        border-bottom: 3px solid #f0f0f0;
        margin-bottom: 3%;
        width: 100%;
    }

    @media (min-width: 1024px) {

        .search-rs {
            display: none !important;
        }

        .header-wrap {
            flex-direction: column;
            gap: 2rem;

        }

        .header-wrap .header-logo {
            flex: unset;
        }

        .header-wrap .header-logo .footer-social-links {
            flex: unset;
            display: flex;
        }

		.cat-responsive {
			display: block !important;
		}

		.cat-mobile {
			display: none !important;
		}

    }

    .search-rs {
        display: flex;
    }
    .search-rs a {
        opacity: 40%;
    }


    .mini-bar a {
        line-height: 1;
        padding: 10px 10px 10px 10px;
        text-align: start;
    }

    .mini-bar .section-members-login-panel {
        display: flex;
        justify-content: start;
        align-items: start;
    }
	#ul_cat div a {
		margin: 8px 0;
	}

    .dot-category {
        width: 4px;
        height: 4px;
        border-radius: 100px;
        display: block;
        background-color: #3f908a;
        margin-right: 3px
    }
    a:has(.dot-category) {
        display: flex;
        align-items: center;
    }

    .visually-hidden {
        position: absolute;
        width: 1px;
        height: 1px;
        margin: -1px;
        padding: 0;
        overflow: hidden;
        clip: rect(0, 0, 0, 0);
        border: 0;
    }

</style>

<template>
    <div class="section-header wrap">

        <header class="header-wrap flex">
                <div class="header-logo" style="display: flex;width: 100%;gap: 25%">
                    <div class="footer-social-links flex">
                        <a href="https://www.facebook.com/thepolroom/" aria-label="link Facebook">
                            <svg class="global-svg" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M22.676 0H1.324C.593 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294H9.689v-3.621h3.129V8.41c0-3.099 1.894-4.785 4.659-4.785 1.325 0 2.464.097 2.796.141v3.24h-1.921c-1.5 0-1.792.721-1.792 1.771v2.311h3.584l-.465 3.63H16.56V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .593 23.408 0 22.676 0"></path>
                            </svg>
                        </a>

                        <a href="https://twitter.com/Political_Room" aria-label="link Twitter">
                            <svg class="global-svg" role="img" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                <path d="M 5.9199219 6 L 20.582031 27.375 L 6.2304688 44 L 9.4101562 44 L 21.986328 29.421875 L 31.986328 44 L 44 44 L 28.681641 21.669922 L 42.199219 6 L 39.029297 6 L 27.275391 19.617188 L 17.933594 6 L 5.9199219 6 z M 9.7167969 8 L 16.880859 8 L 40.203125 42 L 33.039062 42 L 9.7167969 8 z"></path>
                            </svg>
<!--                            <svg class="global-svg" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z"></path>
                            </svg>-->
                        </a>
                        <a href="https://www.instagram.com/thepoliticalroom.tpr/" aria-label="link Instagram">
                            <svg class="global-svg" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"></path>
                            </svg>
                        </a>
                        <!--<a href="https://cms.thepoliticalroom.com/rss-feed" aria-label="link Rss">
                            <svg fill="#000000" height="800px" width="800px" version="1.1" id="Layer_1"
                                 xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                 viewBox="0 0 485 485" xml:space="preserve">
                        <g>
                          <path d="M339.708,400H400c-0.035-86.835-35.341-165.515-92.369-222.578C250.567,120.359,171.953,85.035,85.136,85v60.121
                            C225.512,145.226,339.603,259.505,339.708,400z"/>
                            <path d="M232.451,399.899c0.017,0,0.017,0.101,0.017,0.101h60.397c-0.052-57.304-23.345-109.187-60.996-146.869
                            c-37.664-37.686-89.534-60.979-146.833-61.014v60.139c39.27,0.035,76.409,15.452,104.195,43.291
                            C217.02,323.302,232.385,360.489,232.451,399.899z"/>
                            <path d="M126.821,399.606c11.567,0,21.958-4.629,29.614-12.219c7.586-7.604,12.237-17.925,12.272-29.426
                            c-0.035-11.502-4.686-21.844-12.307-29.466c-7.621-7.586-18.012-12.254-29.579-12.254c-11.555,0-21.928,4.668-29.549,12.237
                            C89.681,336.086,85,346.459,85,357.961c0,11.502,4.681,21.84,12.272,29.426C104.876,394.96,115.266,399.606,126.821,399.606z"/>
                            <path d="M0,0v485h485V0H0z M455,455H30V30h425V455z"/>
                        </g>
                        </svg>
                        </a>
                        <a href="https://www.ivoox.com/the-political-room_aj_19764770_1.html" aria-label="link Podcasts">
                            <svg class="global-svg" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M11.93 24s2.633 0 2.633-7.794c0-1.451-1.18-2.633-2.633-2.633s-2.634 1.182-2.634 2.633C9.296 24 11.93 24 11.93 24zm3.23-2.656c.115-.447.205-.896.275-1.351l.053-.36c.115-.05.23-.098.346-.15 1.828-.828 3.367-2.243 4.348-3.993.447-.803.777-1.67.973-2.572.227-1.008.285-2.059.166-3.088-.105-.963-.361-1.904-.77-2.787-.465-1.039-1.111-1.986-1.924-2.784-.828-.827-1.807-1.505-2.875-1.972-1.098-.496-2.303-.752-3.52-.782-1.22-.03-2.438.166-3.582.603-1.098.419-2.106 1.037-2.979 1.834-.827.752-1.534 1.67-2.046 2.678-.437.858-.736 1.776-.902 2.723-.166.979-.166 1.986-.016 2.98.135.872.391 1.73.768 2.543.888 1.881 2.393 3.444 4.258 4.394.226.104.451.21.692.314.015.121.046.256.06.392.075.438.166.889.271 1.325-.406-.136-.813-.287-1.204-.468-2.152-.976-3.972-2.662-5.101-4.754-.512-.947-.873-1.955-1.098-3.01-.257-1.158-.302-2.377-.15-3.566.15-1.112.466-2.211.933-3.22.556-1.188 1.339-2.286 2.271-3.204.916-.916 2.06-1.684 3.31-2.211C9.02.311 10.42.018 11.828.001c1.412-.015 2.824.24 4.139.758 1.266.498 2.434 1.238 3.43 2.166.965.895 1.76 1.962 2.346 3.139.496.993.842 2.076 1.008 3.175.18 1.144.18 2.317-.016 3.446-.166 1.053-.512 2.091-.979 3.053-1.053 2.122-2.799 3.868-4.92 4.922-.527.256-1.084.481-1.655.661l-.021.023zm.52-4.295l.01-.47c0-.316 0-.632-.046-.943-.015-.121-.045-.226-.075-.346.557-.451 1.023-1.023 1.369-1.67.256-.481.451-1.008.557-1.551.121-.602.15-1.233.061-1.865-.074-.557-.227-1.098-.451-1.61-.285-.616-.677-1.188-1.158-1.67-.497-.481-1.054-.872-1.686-1.159-.692-.3-1.445-.48-2.197-.496-.752-.015-1.52.121-2.227.392-.632.256-1.219.617-1.73 1.083-.513.466-.934 1.008-1.235 1.624-.257.496-.436 1.024-.542 1.58-.105.572-.119 1.159-.045 1.73.075.557.226 1.099.451 1.609.346.768.857 1.445 1.49 2.002l-.091.406c-.06.316-.045.617-.045.947v.422c-1.054-.646-1.927-1.58-2.513-2.663-.347-.617-.587-1.279-.723-1.972-.166-.768-.195-1.564-.09-2.347.09-.707.286-1.399.572-2.032.346-.781.857-1.504 1.459-2.121.617-.617 1.339-1.113 2.121-1.459.873-.391 1.82-.602 2.769-.632.964-.016 1.927.15 2.813.497.813.315 1.551.781 2.197 1.368.631.587 1.174 1.278 1.564 2.047.316.632.557 1.309.678 2.001.121.723.15 1.459.045 2.182-.09.707-.285 1.399-.588 2.046-.586 1.31-1.594 2.438-2.828 3.176l.114-.106zm-3.75-9.575c1.465 0 2.654 1.188 2.654 2.656 0 1.473-1.189 2.662-2.654 2.662-1.467 0-2.655-1.189-2.655-2.648s1.188-2.649 2.655-2.649v-.021z"></path>
                            </svg>
                        </a>-->
                        <a href="https://www.youtube.com/channel/UCRmAzmoLNZxCvBQNlhtKLPw" aria-label="link YouTube">
                            <svg class="global-svg" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                <path class="a"
                                      d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"></path>
                            </svg>
                        </a>
                    </div>
                    <h1 class="is-logo">
                        <NuxtLink :to="localePath({ name: 'index' })">
                            <img src="/logo.svg" alt="Logo TPR">
                        </NuxtLink>
                        <span class="visually-hidden">The Political Room</span>
                    </h1>
                </div>
                <div class="header-nav">
                    <nav class="nav-wrap">
                        <label for="toggle" class="nav-label hamburger hamburger-minus">
                            <span class="hamburger-box">
                                <span class="hamburger-inner"></span>
                            </span>
                        </label>
                        <input type="checkbox" id="toggle" class="nav-toggle">
                        <ul class="nav-list">

                            <li class="nav-list-item">
                                <NuxtLink :to="localePath({ path: '/' })" class="nav-link">{{$t('settings.headerMenu.blog')}}</NuxtLink>
                                <span class="nav-dot nav-dot-current" v-if="routeData.path === '/' || routeData.path === '/en'"></span>
                            </li>
							<li class="nav-list-item cat-responsive" style="position: relative;display: none"><!--@mouseleave="unDisplayList()"-->

								<NuxtLink id="cat_custom" style="cursor: pointer" @click="displayListCat()" class="nav-link">Categorías</NuxtLink>

								<div @mouseleave="unDisplayList()"  id="ul_cat" style="display: none;
									 position: absolute;z-index: 999;background-color: transparent;
									width: 100%;top: 5px;left: 4%;padding: 20px 0">
									<div style="background-color: #fff;display: flex;justify-content: start;flex-direction: column;
									align-items: start; width: 7rem;padding: 1rem;">
										<NuxtLink @click="unDisplayList()" :to="localePath({ name: 'categories-slug', params: { slug: 'politica' } })">Política</NuxtLink>
										<NuxtLink @click="unDisplayList()" :to="localePath({ name: 'categories-slug', params: { slug: 'defensa-1' } })">Defensa</NuxtLink>
										<NuxtLink @click="unDisplayList()" :to="localePath({ name: 'categories-slug', params: { slug: 'economia' } })">Economía</NuxtLink>
										<NuxtLink @click="unDisplayList()" :to="localePath({ name: 'categories-slug', params: { slug: 'opinion' } })">Opinión</NuxtLink>
										<NuxtLink @click="unDisplayList()" :to="localePath({ name: 'categories-slug', params: { slug: 'entrevistas' } })">Entrevistas</NuxtLink>
									</div>

								</div>

							</li>
							<li class="nav-list-item cat-mobile" style="position: relative"><!--@mouseleave="unDisplayList()"-->
								<NuxtLink id="cat_custom" style="cursor: pointer" @click="displayListCatMobile" class="nav-link">Categorías</NuxtLink>
								<div id="ul_cat_mobile" class="ul-cat-mobile"
									 style="display: none;justify-content: start;align-items: start;
									 flex-direction: column;padding-left: 3px">
									<NuxtLink @click="unDisplayListMobile()" :to="localePath({ name: 'categories-slug', params: { slug: 'politica' } })"><span class="dot-category"></span>Política</NuxtLink>
									<NuxtLink @click="unDisplayListMobile()" :to="localePath({ name: 'categories-slug', params: { slug: 'defensa-1' } })"><span class="dot-category"></span>Defensa</NuxtLink>
									<NuxtLink @click="unDisplayListMobile()" :to="localePath({ name: 'categories-slug', params: { slug: 'economia' } })"><span class="dot-category"></span>Economía</NuxtLink>
									<NuxtLink @click="unDisplayListMobile()" :to="localePath({ name: 'categories-slug', params: { slug: 'opinion' } })"><span class="dot-category"></span>Opinión</NuxtLink>
									<NuxtLink @click="unDisplayListMobile()" :to="localePath({ name: 'categories-slug', params: { slug: 'entrevistas' } })"><span class="dot-category"></span>Entrevistas</NuxtLink>

								</div>
							</li>
                            <li class="nav-list-item">
                                <NuxtLink @click="unDisplayListMobile(true)" :to="localePath({ name: 'about' })" class="nav-link">{{$t('settings.headerMenu.about')}}</NuxtLink>
                                <span class="nav-dot nav-dot-current" v-if="routeData.name === 'about___es' || routeData.name === 'about___en'"></span>
                            </li>

                            <li class="nav-list-item">
                                <NuxtLink @click="unDisplayListMobile(true)" :to="localePath({ name: 'colaborate' })" class="nav-link">{{$t('settings.headerMenu.colaborate')}}</NuxtLink>
                                <span class="nav-dot nav-dot-current" v-if="routeData.name === 'colaborate___es' || routeData.name === 'colaborate___en' || routeData.name === 'colaborate-id___es' || routeData.name === 'colaborate-id___en' "></span>
                            </li>

                            <li class="nav-list-item">
                                <NuxtLink @click="unDisplayListMobile(true)" :to="localePath({ name: 'infographic' })" class="nav-link">{{$t('settings.headerMenu.infographics')}}</NuxtLink>
                            </li>
                            <li class="nav-list-item">
                                <NuxtLink @click="unDisplayListMobile(true)" :to="localePath({ name: 'podcast' })" class="nav-link">Podcasts</NuxtLink>
                            </li>
                            <li class="nav-list-item">
                                <NuxtLink @click="unDisplayListMobile(true)" :to="localePath({ name: 'webinar' })" class="nav-link">{{$t('settings.headerMenu.webinars')}}</NuxtLink>
                            </li>

                            <li class="nav-list-item">
                                <NuxtLink @click="unDisplayListMobile(true)" :to="localePath({ name: 'contact' })" class="nav-link">{{$t('settings.headerMenu.contact')}}</NuxtLink>
                            </li>

                            <li class="section-members-login-panel" style="">
                                <template v-if="status === 'authenticated'">
                                    <NuxtLink v-if="currentRoute.name !== 'account___es' && currentRoute.name !== 'account___en'" :to="localePath({ name: 'account' })" class="members-account">{{$t('settings.headerMenu.account')}}</NuxtLink>
                                    <NuxtLink style="cursor: pointer;" class="members-signout" @click.native="customSignOut()">{{$t('settings.headerMenu.signout')}}</NuxtLink>

                                </template>
                                <template v-else>
                                    <NuxtLink :to="localePath({ name: 'account-signin' })" class="members-signin">{{$t('settings.headerMenu.signin')}}</NuxtLink>
                                    <NuxtLink v-if="currentRoute.name !== 'account-signup___es' && currentRoute.name !== 'account-signup___en'" :to="localePath({ name: 'account-signup' })" class="members-signup">{{$t('settings.headerMenu.signup')}}</NuxtLink>
                                </template>
                            </li>

                            <li class="nav-list-item search-open" >
                                <NuxtLink :to="localePath({ name: 'search' })" class="nav-link">
                                    <span>Buscador</span>
                                    <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18.420346,15.5800244 L24,21.1596784 L21.1596784,24 L15.5800244,18.420346 C13.9925104,19.4717887 12.088789,20.0841064 10.0420532,20.0841064 C4.49598037,20.0841064 0,15.5881261 0,10.0420532 C0,4.49598037 4.49598037,0 10.0420532,0 C15.5881261,0 20.0841064,4.49598037 20.0841064,10.0420532 C20.0841064,12.088789 19.4717887,13.9925104 18.420346,15.5800244 Z M10.0420532,16.0672851 C13.3696969,16.0672851 16.0672851,13.3696969 16.0672851,10.0420532 C16.0672851,6.71440951 13.3696969,4.01682129 10.0420532,4.01682129 C6.71440951,4.01682129 4.01682129,6.71440951 4.01682129,10.0420532 C4.01682129,13.3696969 6.71440951,16.0672851 10.0420532,16.0672851 Z"></path>
                                    </svg>
                                </NuxtLink>
                                <div class="search-rs" >
                                    <a href="https://www.facebook.com/thepolroom/" aria-label="link Facebook">
                                        <svg class="global-svg" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M22.676 0H1.324C.593 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294H9.689v-3.621h3.129V8.41c0-3.099 1.894-4.785 4.659-4.785 1.325 0 2.464.097 2.796.141v3.24h-1.921c-1.5 0-1.792.721-1.792 1.771v2.311h3.584l-.465 3.63H16.56V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .593 23.408 0 22.676 0"></path>
                                        </svg>
                                    </a>
                                    <a href="https://twitter.com/Political_Room" aria-label="link Twitter">
                                        <svg class="global-svg" role="img" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M 5.9199219 6 L 20.582031 27.375 L 6.2304688 44 L 9.4101562 44 L 21.986328 29.421875 L 31.986328 44 L 44 44 L 28.681641 21.669922 L 42.199219 6 L 39.029297 6 L 27.275391 19.617188 L 17.933594 6 L 5.9199219 6 z M 9.7167969 8 L 16.880859 8 L 40.203125 42 L 33.039062 42 L 9.7167969 8 z"></path>
                                        </svg>
                                    </a>
                                    <a href="https://www.instagram.com/thepoliticalroom.tpr/" aria-label="link Instagram">
                                        <svg class="global-svg" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"></path>
                                        </svg>
                                    </a>
                                    <a href="https://www.youtube.com/channel/UCRmAzmoLNZxCvBQNlhtKLPw" aria-label="link YouTube">
                                        <svg class="global-svg" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                            <path class="a"
                                                  d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"></path>
                                        </svg>
                                    </a>
                                </div>
                            </li>

                            <li class="nav-list-item search-open">
                                <div class="container-icon-fav" style="display: flex;align-items: center;">
                                    <NuxtLink :to="localePath({ name: 'favourites' })" v-if="status === 'authenticated'">
                                        <svg id="heart_svg" xmlns="http://www.w3.org/2000/svg" width="40px" height="40px" viewBox="0 0 16 16" fill="none">
                                            <path d="M1.24264 8.24264L8 15L14.7574 8.24264C15.553 7.44699 16 6.36786 16 5.24264V5.05234C16 2.8143 14.1857 1 11.9477 1C10.7166 1 9.55233 1.55959 8.78331 2.52086L8 3.5L7.21669 2.52086C6.44767 1.55959 5.28338 1 4.05234 1C1.8143 1 0 2.8143 0 5.05234V5.24264C0 6.36786 0.44699 7.44699 1.24264 8.24264Z" fill="#ff0000"/>
                                        </svg>
                                    </NuxtLink>
                                    <NuxtLink :to="localePath({ name: 'achievements' })" class="nav-link">
                                        <svg style="width:30px;height:30px" role="img" height="64px" width="64px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path style="fill:#930B1F;" d="M379.586,52.966l-35.31,52.966h8.828v35.31h35.31v132.326c2.807-1.156,5.597-2.348,8.289-3.725 c24.135-12.332,42.161-34.039,52.224-59.207L512,52.966H379.586z"></path> <path style="fill:#930B1F;" d="M123.586,141.241h35.31v-35.31h8.828l-35.31-52.966H0l63.073,157.67 c10.063,25.167,28.089,46.874,52.224,59.207c2.692,1.377,5.482,2.569,8.289,3.725V141.241z"></path> </g> <path style="fill:#F8D832;" d="M388.414,370.759L256,459.034l-132.414-88.276V141.241h35.31v-35.31h194.207v35.31h35.31V370.759z"></path> <path style="fill:#C4A316;" d="M158.897,351.862L256,416.595l97.103-64.733V176.555h-35.31v-35.31H194.207v35.31h-35.31V351.862z"></path> <g> <path style="fill:#6B0F21;" d="M61.793,79.448H14.124c-1.156,0-2.251,0.256-3.266,0.662l6.797,16.993h44.138 c4.873,0,8.828-3.955,8.828-8.828C70.621,83.403,66.666,79.448,61.793,79.448"></path> <path style="fill:#6B0F21;" d="M70.621,114.759H28.248c-1.156,0-2.251,0.256-3.266,0.662l6.797,16.993h38.841 c4.873,0,8.828-3.955,8.828-8.828C79.448,118.713,75.494,114.759,70.621,114.759"></path> <path style="fill:#6B0F21;" d="M88.276,150.069H42.372c-1.156,0-2.251,0.256-3.266,0.662l6.797,16.993h42.372 c4.873,0,8.828-3.955,8.828-8.828C97.103,154.024,93.149,150.069,88.276,150.069"></path> <path style="fill:#6B0F21;" d="M497.879,79.448H450.21c-4.882,0-8.828,3.955-8.828,8.828c0,4.873,3.946,8.828,8.828,8.828h44.138 l6.797-16.993C500.13,79.704,499.036,79.448,497.879,79.448"></path> <path style="fill:#6B0F21;" d="M487.019,115.418c-1.015-0.406-2.11-0.662-3.266-0.662H441.38c-4.882,0-8.828,3.955-8.828,8.828 c0,4.882,3.946,8.828,8.828,8.828h38.841L487.019,115.418z"></path> <path style="fill:#6B0F21;" d="M466.097,167.724l6.797-16.993c-1.015-0.406-2.11-0.662-3.266-0.662h-45.903 c-4.882,0-8.828,3.955-8.828,8.828c0,4.873,3.946,8.828,8.828,8.828H466.097z"></path> </g> </g> </g></svg>
                                    </NuxtLink>
                                </div>
                            </li>
                        </ul>
                    </nav>
                </div>

<!--                <div class="blog-description flex">Medio de comunicación independiente</div>-->

            </header>
        </div>
    <div class="header-bottom"></div>
</template>



<style scoped>

    @media screen and (min-width: 1021px) {


        .container-icon-fav {
            flex-direction: row-reverse;
        }

        .nav-wrap > .nav-list {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
        }


    }

    #heart_svg {
        height: 22px !important;
        width: 22px !important;
    }

    .members-signup:focus {
        color:white;
    }


</style>
